import { render, staticRenderFns } from "./HrBasicCorp.vue?vue&type=template&id=1dc33e88&scoped=true&"
import script from "./HrBasicCorp.vue?vue&type=script&lang=js&"
export * from "./HrBasicCorp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc33e88",
  null
  
)

export default component.exports